import React from "react"
import { FormattedMessage } from "react-intl"

import { Box, H2, H3, P } from "@bullseye/components"

import SignUpButton from "../SignUpButton"

type ItemType = { title: string; text: string }

const firstRowItems: ItemType[] = [
  {
    title: "75% of members",
    text: "said they connect with others more often thanks to Hank",
  },
  {
    title: "7 out of 10 members",
    text: "feel significantly less lonely since joining",
  },
  {
    title: "<10 people per outing",
    text: "means quality time, not crowded mixers",
  },
]

const secondRowItems: ItemType[] = [
  {
    title: "Connect faster",
    text: "through shared interests and experiences",
  },
  {
    title: "Choose from 1000s of activities",
    text: "ranging from the casual to the creatively inspired",
  },
]

const EmptyCalendar = () => {
  const renderRow = (data: ItemType[]) => (
    <Box className="flex max-w-[1080px] flex-col flex-nowrap justify-around g-10 md:flex-row md:g-6">
      {data.map((item) => (
        <Box className="flex-1" key={item.title}>
          <H3 className="mb-2 text-center text-primary-900">{item.title}</H3>
          <P size="lg" className="text-center">
            {item.text}
          </P>
        </Box>
      ))}
    </Box>
  )

  return (
    <Box className="flex items-center px-4 pt-20 g-10">
      <Box className="max-w-[800px] g-2">
        <H2 className="text-center text-brand-indigo-1">
          <FormattedMessage id="home.emptyCalendar.title" />
        </H2>
        <P size="lg" className="text-center">
          <FormattedMessage id="home.emptyCalendar.subtitle" />
        </P>
      </Box>
      {renderRow(firstRowItems)}
      {renderRow(secondRowItems)}
      <SignUpButton>
        <FormattedMessage id="general.getStarted.free" />
      </SignUpButton>
    </Box>
  )
}

export default EmptyCalendar
